import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { ToastController, AlertController, LoadingController, NavController, IonicSafeString } from '@ionic/angular';
// Reemplazado: llamadas nativas con window.open('tel:')
// import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import * as moment from 'moment';

import { Constants } from '../../../providers/constants/constants';
import { AppointmentService } from './../appointment/appointment.service';
import { VehiculosService } from './../vehiculos/vehiculos.service';
import { SessionService } from '../session/session.service';

@Injectable({ providedIn: 'root' })
export class ToolsService {
  constants = Constants;
  moment = moment;
  constructor(
    private router: Router,
    public navController: NavController,
    public toastController: ToastController,
    public alertController: AlertController,
    // callNumber plugin reemplazado
    public loadingController: LoadingController,
    public appointmentService: AppointmentService,
    public vehiculosService: VehiculosService,
    private currencyPipe: CurrencyPipe,
    private sessionService: SessionService,
    // private inAppBrowser: InAppBrowser
  ) { }

  /**
   * @description Traza el flujo de registro / login / verificación / logout (sin email, token ni contraseña).
   * @param event Nombre del evento de flujo a registrar.
   * @param data Datos adicionales seguros para depuración en consola.
   */
  flowTrace(event: string, data: Record<string, unknown> = {}) {
    const payload = { event, t: Date.now(), ...data };
    console.warn('[AgendateFlow]', event, payload);
  }

  /**
   * Convierte una cadena HTML en `IonicSafeString` para permitir su renderizado
   * en componentes Ionic que aceptan contenido HTML (por ejemplo, `AlertController.message`).
   * Debe usarse solo con contenido controlado o previamente sanitizado.
   *
   * @param message Contenido HTML a renderizar.
   * @returns Instancia de `IonicSafeString` compatible con Ionic.
   */
  toSafeHtml(message: string): IonicSafeString {
    return new IonicSafeString(message);
  }

  statusService(data) {
    if (data.status === 401) {
      this.clearDataRedirectLogin();
    } else {
      // si se presenta un error diferente no detectado y se reporta al usuario para que nos envie notificacion de error
      this.alertErrorInformationWs({ msnCode: 0 }, true, this.constants.contactAgendate.supportTeam.nameKeyTeam);
    }
  }

  clearDataRedirectLogin() {
    this.flowTrace('auth.clearDataRedirectLogin', { action: 'localStorage.clear then navigate /login' });
    localStorage.clear();
    localStorage.setItem(this.constants.localStorage.initAppSlider, 'true');
    this.sessionService.clearSession();
    this.router.navigate(['/login']);
  }

  getDataContactTeamAgendate(typeTeam: string) {
    const dataTeam = this.constants.contactAgendate[typeTeam];
    // <ion-icon name="mail" class="text-color-medium"></ion-icon> <a class="enlaces-no-decoration" href="mailto:${dataTeam.email}">${dataTeam.email}</a><br><br>
    // <ion-icon name="call" class="text-color-medium"></ion-icon> <a class="enlaces-no-decoration" href="tel:${dataTeam.cellPhoneNumber}">${dataTeam.cellPhoneNumber}</a><br><br>
    const message = `<ion-icon name="logo-whatsapp" class="text-color-medium"></ion-icon> <a class="enlaces-no-decoration" target="_blank" href="https://wa.me/57${dataTeam.whatsapp}">${dataTeam.whatsapp}</a>`;
    return message;
  }
  // para ejecutar pruebas de alertas
  // const dataError = {
  //   msnCode: 5011
  // };
  // this.toolsService.alertErrorInformationWs(dataError, true, 'salesTeam');
  async alertErrorInformationWs(dataError: any, isShowContact: boolean = false, typeTeam: string) {
    const dataMessageError = this.constants.services.msnCode.filter((idCode) => {
      return idCode.id === dataError.msnCode;
    });
    if (dataMessageError.length > 0) {
      const dataContact = isShowContact ? this.getDataContactTeamAgendate(typeTeam) : '';
      const headerTitle = dataMessageError[0].title;
      const informationalMessage = `${dataMessageError[0].messageDescription} <br><br> ${dataContact}`;
      const alert = await this.alertController.create({
        header: headerTitle,
        message: this.toSafeHtml(`<p class="ion-text-left text-primary">${informationalMessage}</p>`),
        translucent: true,
        animated: true,
        mode: 'ios',
        backdropDismiss: false,
        buttons: [
          {
            text: 'Aceptar',
            handler: () => {
              this.validateActionBtnAlertHandler(dataError);
            }
          }
        ]
      });
      await alert.present();
    } else {
      await this.presentToast(dataError.message.messageDescription);
    }
  }

  /**
   * @description valida los codigos de error dependiendo el codigo se navega a otra vista o se cierra el modal
   * @param dataError data del error que se ppresento en el web services
   */
  validateActionBtnAlertHandler(dataError: any) {
    switch (dataError.msnCode) {
      case 5012:
        this.router.navigate(['/home']);
        break;
      case 5013:
        this.router.navigate(['/home']);
        break;
    }
  }

  async alertAppointmentDetail(data: any) {
    const horaFin = (data.citas.fecha_fin) ? ` a ${moment(data.citas.fecha_fin).format('h:mm A')}` : '';
    const valorDelProcedimiento = data.citas.procedimientos?.caracteristicas ? this.currencyPipe.transform(data.citas.procedimientos?.caracteristicas.valor_servicio.valor, 'COP', '$', '1.0-0', 'es-ES') : '';
    const valorDelProcedimientoHtml = valorDelProcedimiento ? `<strong>Valor: </strong> ${valorDelProcedimiento}<br>` : '';
    const alert = await this.alertController.create({
      // *ngIf="valorDelProcedimiento"
      header: 'Detalle de la cita',
      message: this.toSafeHtml(`<p class="ion-text-left text-primary">
                  <strong>Cliente:</strong> ${data.usuario.nombres} ${data.usuario.apellidos}<br>
                  <strong>Fecha:</strong> <span class="text-capitalize">${ this.parseDates(data.citas.fecha, 1)} ${horaFin}</span><br>
                  ${valorDelProcedimientoHtml}
                  <strong>Tipo de cita:</strong> ${data.citas.procedimientos.nombre}<br>
                  <strong>Atendido por:</strong> ${data.citas.usuario_atendedor.nombres} ${data.citas.usuario_atendedor.apellidos}<br>
                  <strong>Cita creada por:</strong> ${data.citas.usuario_agendador.nombres} ${data.citas.usuario_agendador.apellidos}<br>
                  <strong>Nota:</strong> ${data.citas.nota}
                </p>`),
      translucent: true,
      animated: true,
      mode: 'ios',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Aceptar',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

  /**
   * @description Funcion para sacar un alert de notificacion simple recibe un titulo y mensaje con una opcion de apceptar
   * @param data se debe pasar en formato json el ejemplo es {titulo: '', mensaje: ''}
   * @param redirectUrl url a la que se va a redirigir al presionar el botón de aceptar
   * @param dataRedirectUrl data que se envia a vistas de la app, en donde se reciben al terminar un proceso el usuario es redirigido
   * a la url que se envie en este parametro, ejemplo en la vista de buscar usuario nueva cita
   * @param nameBtnAction nombre del boton que va a salir en la alerta
   */
  async alertNotificacionSimple(data: any, redirectUrl: string = null, dataRedirectUrl: any = {}, nameBtnAction: string = 'Aceptar') {
    const alert = await this.alertController.create({
      header: data.titulo,
      message: `${data.mensaje}`,
      translucent: true,
      animated: true,
      mode: 'ios',
      buttons: [
        {
          text: nameBtnAction,
          handler: () => {
            if (redirectUrl) {
              // this.router.navigate([redirectUrl, dataRedirectUrl]);
              this.navController.navigateForward([redirectUrl, dataRedirectUrl]);
            }
          }
        }
      ]
    });
    await alert.present();
  }

  /**
   * @description Reenvia notificacion de cita a cliente
   * @param data id de la cita a reenviar
   */
  forwardAppointment(data: any) {
    this.appointmentService.getForwardAppointment(data)
      .subscribe({
        next: (response) => {
          const typeResponse = response['type'];
          if (typeResponse === this.constants.services.types.success) {
            this.presentToast(this.constants.appointment.notificationForward);
          } else if (typeResponse === this.constants.services.types.error) {
            this.alertErrorInformationWs(response, true, this.constants.contactAgendate.salesTeam.nameKeyTeam);
          }
        }, error: (err) => {
          this.statusService(err);
        }
      });
  }

  /**
   * @description Notificación tipo toast
   * @param message mensaje a mostrar
   */
  async presentToast(message: string, duration: number = 3000) {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'middle',
      cssClass: 'toast-edit',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  /**
   * Funcion auxiliar para visualizacion del loading cuando se ejecuten eventos que
   * requieren de consultar webservis
   * @param message, para pasarle el texto mientras esta cargando
   * @param spinner, define el tipo de spinner que se va a utilizar
   */
  async presentLoadingNoLimit(message, spinner) {
    const loading = await this.loadingController.create({
      message: message,
      spinner: spinner,
      mode: 'ios'
    });
    await loading.present();
    return loading;
  }

  /**
   * @description Realiza la pantalla de espera para la carga de informacion con opciones
   */
  async presentLoadingWithOptions(message: string = 'Please wait...,', duration: number = 5000, spinner: any = null, translucent: boolean = true, cssClass: string = 'custom-class custom-loading') {
    const loading = await this.loadingController.create({
      spinner: spinner,
      duration: duration,
      message: message,
      translucent: translucent,
      cssClass: cssClass,
      mode: 'ios'
    });
    return await loading.present();
  }

  openCall(numberPhone: string) {
    const telUrl = `tel:${numberPhone}`;
    window.open(telUrl, '_system');
  }

  async messageWhatsapp(numberPhone: any) {
    await Browser.open({ url: `https://wa.me/57${numberPhone}` });
    // await Browser.open({ url: `https://api.whatsapp.com/send?phone=+57${numberPhone}` });
    // window.location.href = `whatsapp://send?phone=+57${numberPhone}`;
  }

  validateUrlInactivateMenu(url) {
    if (this.constants.inactivateUrlNavigationMenu.indexOf(url) !== -1) {
      return true;
    }
    return false;
  }

  updateUserToken(token: string) {
    this.sessionService.updateToken(token);
  }

  validateNumber(numberV: any) {
    if (!/^([0-9])*$/.test(numberV)) {
      console.log('return false');

      return false;
    } else {
      console.log('return true');

      return true;
    }
  }

  /**
   * @description normaliza valores de inputs string y evita errores al usar trim en null/undefined
   */
  sanitizeInputString(value: any, fallback: string = ''): string {
    return typeof value === 'string' ? value.trim() : fallback;
  }

  /**
   * @description pasea fechas con momment
   * @param dateParse fecha a parsear
   * @param typeParse tipo de formato a parsear
   */
  parseDates(dateParse: any, typeParse: number) {
    // .lang.('es')
    switch (typeParse) {
      case 0:
        // valida que el formato de hora sea valido devuelve true si es valido
        return moment(dateParse, 'HH:mm').isValid();
        break;
      case 1:
        const day = moment(dateParse).locale('es').format('dddd');
        const dayMonth = moment(dateParse).format('D');
        const month = moment(dateParse).locale('es').format('MMMM');
        const year = moment(dateParse).format('YYYY');
        const hour = moment(dateParse).format('h:mm A');
        return `${day}, ${dayMonth} de ${month}. ${year} - ${hour}`;
        break;
      case 2:
        // convierte la hora en formato de 12h Ejm: 03:00 PM
        return moment(dateParse, 'HH:mm').format('hh:mm a');
        break;
      case 3:
        // devuelve el dia de la semana Ejm: Mart
        return moment(dateParse).locale('es').format('ddd');
        break;
    }
  }

  getStatusCodeErrorsWs(idCode: number) {
    return this.constants.services.msnCode.find(msnCode => msnCode.id === idCode);
  }

  getTipoServicioOrganizacion(tipoServicio: string): boolean {
    const { organizaciones } = JSON.parse(localStorage.getItem(this.constants.localStorage.user) || '{}');
    return organizaciones?.tipo_servicio === tipoServicio;
  }

  /**
   * @description inicia un servicio desde cero, se crea desde tools services por que es reutilizado en otros componentes
   * @param dataServicio 
   */
  addClienteAlServicio(dataServicio: any, esAdicionarNota: boolean = false) {
    // Realizar el split de la propiedad checklist y lo agrega 
    if (dataServicio.checklist && typeof dataServicio.checklist === 'string') {
      dataServicio.checklist = dataServicio.checklist.split(',').map(item => this.sanitizeInputString(item));
    }

    this.vehiculosService.postIniciarServicioVehiculo(JSON.stringify(dataServicio))
      .subscribe({
        next: (response: any) => {
          if (response.name === this.constants.services.codeName.G200) {
            const mensajeToast =  esAdicionarNota ? this.constants.servicioVehiculos.notificationNotaGuardada : this.constants.servicioVehiculos.notificationCreated; 
            this.presentToast(mensajeToast);
            this.navController.navigateForward(['/home']);
          }
        },
        error: (err) => {
          this.statusService(err);
        }
      });
  }

  /**
   * Abre el selector de fecha nativo del navegador para un input `type="date"`.
   * Usa `showPicker()` cuando está disponible; de lo contrario, enfoca y simula clic.
   *
   * @param inputId Identificador del input HTML de tipo fecha.
   */
  openDatePicker(inputId: string): void {
    const input = document.getElementById(inputId) as HTMLInputElement | null;
    if (!input) {
      return;
    }

    if (typeof input.showPicker === 'function') {
      try {
        input.showPicker();
      } catch {
        input.focus();
        input.click();
      }
    } else {
      input.focus();
      input.click();
    }
  }

  cambiarEstadoServicio(dataServicio: any, mensajeToast: string) {
    this.vehiculosService.postIniciarServicioVehiculo(JSON.stringify(dataServicio))
      .subscribe({
        next: (response: any) => {
          if (response.name === this.constants.services.codeName.G200) {
            this.presentToast(mensajeToast);
            this.navController.navigateForward(['/home']);
          }
        },
        error: (err) => {
          this.statusService(err);
        }
      });
  }

  /**
   * Valida si la fecha recibida es menor a la fecha actual.
   * 
   * @param fechaValidar - Fecha a validar en formato string (preferiblemente 'YYYY-MM-DD' o compatible con moment).
   * @returns `true` si la fecha recibida es menor a la fecha actual, `false` si es igual o posterior.
   * 
   * @example
   * // Supongamos que hoy es '2024-06-20'
   * validarFechaNacimiento('2020-01-01') // true
   * validarFechaNacimiento('2025-01-01') // false
   */
  validarFechaNacimiento(fechaValidar: string): boolean {
    const fechaActual = moment().format('YYYY-MM-DD'); // Fecha actual para hacer validaciones
    // Retorna true si la fecha actual es después de la fecha a validar (es decir, fechaValidar < fechaActual)
    return moment(fechaActual).isAfter(moment(fechaValidar).format('YYYY-MM-DD'));
  }

  private getVehiculoAlquilerDraftKeys(vehicleId?: string) {
    const ls = this.constants.localStorage;
    const suffix = vehicleId ? `_${vehicleId}` : '';
    return {
      form1: `${ls.vehiculoAlquilerDraftForm1}${suffix}`,
      form2: `${ls.vehiculoAlquilerDraftForm2}${suffix}`,
      paso: `${ls.vehiculoAlquilerDraftPaso}${suffix}`,
    };
  }

  tieneBorradorVehiculoAlquiler(vehicleId?: string): boolean {
    const keys = this.getVehiculoAlquilerDraftKeys(vehicleId);
    return [keys.form1, keys.form2, keys.paso].some((key) => !!localStorage.getItem(key));
  }

  limpiarDatosVehiculoAlquiler(vehicleId?: string): void {
    const ls = this.constants.localStorage;
    const keys = this.getVehiculoAlquilerDraftKeys(vehicleId);
    localStorage.removeItem(keys.form1);
    localStorage.removeItem(keys.form2);
    localStorage.removeItem(keys.paso);
    if (!vehicleId) {
      localStorage.removeItem(ls.idProcesoRegistroOwner);
      localStorage.removeItem(ls.idProcesoRegistroVehicle);
    }
  }
}


